// Global Instructions Rule Applied!

import React from 'react'
import { DownloadsForm } from './components/DownloadsForm.tsx'

export default function DownloadsPage() {
  return (
    <div className='h-full overflow-hidden'>
      <div className='w-full h-full flex flex-col bg-white p-2 overflow-hidden'>
        <DownloadsForm />
      </div>
    </div>
  )
}
